import Vue from 'vue'

export default {
  setObjectsPeriod(state, period) {
    state.objectsPeriod = period
  },
  setObjectSelected(state, object) {
    state.objectSelected = object
  },
  setObjectDetailsSelected(state, object) {
    state.objectDetailsSelected = object
  },
  setObjectDetailsInfo(state, info) {
    state.objectDetailsInfo = info
  },
  setObjectPublicFilters(state, filters) {
    state.objectPublicFilters = {
      ...state.objectPublicFilters,
      ...filters
    }
    localStorage.setItem('publicFilters', JSON.stringify(state.objectPublicFilters))
  },
  updateObjectLayer(state, params) {
    Vue.set(state.objectLayers, params.index, params.value)
  },

  /**
   * Поиск слоя в иерархии по массиву родителей parents и по id слоя и обновление слоя в иерархии
   * @param {*} state
   * @param {*} param1
   */
  updateObjectLayerByLayer(state, { layer }) {
    //Получение массива в котором храниться слой по массиву идентификаторов родительских слоев
    let objectLayers = (layer.parents || []).reduce((result, parentLayerId) => {
      const parentLayerById = result.find((layerItem) => {
        return layerItem.id === parentLayerId
      })

      if (!parentLayerById) {
        return result
      }

      return parentLayerById.children || result
    }, state.objectLayers)

    //Получение слоя по идентификатору
    let objectLayerIndex = objectLayers.findIndex((layerItem) => {
      return layerItem.id === layer.id
    })

    if (objectLayerIndex > -1) {
      objectLayers.splice(objectLayerIndex, 1, layer)
    }
  },

  /**
   * Добавление слоя в иерархию
   * @param {*} state
   * @param {*} param1
   */
  addObjectLayer(state, { layer }) {
    //Поиск родителя и получение его массива children
    let children = (layer.parents || []).reduce((result, parentLayerId) => {
      const parentLayer = result.find((layerItem) => {
        return layerItem.id === parentLayerId
      })

      if (!parentLayer) {
        return []
      }

      if (!Array.isArray(parentLayer.children)) {
        Vue.set(parentLayer, 'children', [])
      }
      return parentLayer.children
    }, state.objectLayers)

    children.push(layer)
  },

  updateObjectLayers(state, layers) {
    state.objectLayers = layers
  },
  updateLayersInfo(state, layers) {
    state.objectLayersInfo = Object.assign(state.objectLayersInfo, layers)
  },
  updateLayersInfoProperty(state, layers) {
    state.objectLayersInfo = Object.assign(state.objectLayersInfo, layers)
  },
  updateObjectItems(state, data) {
    state.objectLayerItems = Object.assign(state.objectLayerItems, data)
  },
  updateObjectLayerSettings(state, data) {
    state.objectLayerSettings = Object.assign(state.objectLayerSettings, data)
  },
  setObjectLayerSettings(state, data) {
    state.objectLayerSettings = data
  },
  setObjectLayersInfo(state, layers) {
    state.objectLayersInfo = layers
  },
  updateMapData(state, data) {
    state.objectMapData = Object.assign(state.objectMapData, data)
  },
  setMapData(state, data) {
    state.objectMapData = data
  },
  setObjectMapRequestTime(state, data) {
    const timeMap = {}
    for (let key in data) {
      timeMap[key] = new Date().getTime()
    }
    state.objectMapRequestTime = {
      ...state.objectMapRequestTime,
      ...timeMap
    }
  },
  setObjectMapCacheUpdated(state, data) {
    state.objectMapCacheUpdated = data
  },
  update3DMapData(state, data) {
    state.object3DMapData = Object.assign({}, state.object3DMapData, data)
    this.commit('setObjectMapRequestTime', data)
  },
  set3DMapData(state, data) {
    state.object3DMapData = data
    this.commit('setObjectMapRequestTime', data)
  },
  forceClosePanels(state, data) {
    state.forceClosePanels = data
  },
  forceDefaultVisibilityPanels(state, data) {
    state.forceDefaultVisibilityPanels = data
  },
  setObjectMapParams(state, data) {
    state.objectMapParams = data
  },
  setObjectExactMapParams(state, data) {
    state.objectExactMapParams = data
  },
  setObjectStaticInfo(state, data) {
    state.objectStaticInfo = data
  },
  setObjectMapCenter(state, data) {
    state.forceObjectMapCenter = data
  },
  setObjectMapBounds(state, data) {
    state.forceObjectMapBounds = data
  },
  setObjectContainerTypes(state, data) {
    state.objectContainerTypes = data
  },
  setShowContainerRoute(state, data) {
    state.objectShowContainerRoute = data
  },
  setObjectLoadingData(state, action) {
    state.objectLoadingData = action ? state.objectLoadingData + 1 : state.objectLoadingData - 1
  },
  setObjectZoneGroupMode(state, data) {
    state.objectZoneGroupMode = data
  },
  setObjectWastes(state, data) {
    state.objectWastes = data
  },
  setObjectWasteSelected(state, data) {
    state.objectWasteSelected = data
  },
  setObjectTreatmentSelected(state, data) {
    state.objectTreatmentSelected = data
  },
  setObjectFilterList(state, data) {
    state.objectFilterList = data
  },
  setObjectFilters(state, data) {
    state.objectFilters = data
  },
  setObjectFilterDict(state, data) {
    state.objectfilterDict = data
  },

  /**
   * Скрыть все слои (Мутация для старой версии списка слоев)
   * TODO: удалить после окончательно перехода
   * @param {*} state
   */
  hideAllLayers(state) {
    if (!state.objectLayersInfo) {
      return
    }

    let result = {}
    Object.entries(state.objectLayersInfo).forEach(([key, layerInfo]) => {
      hideLayer(layerInfo)
      result[key] = { ...layerInfo }
    })

    state.objectLayersInfo = result
  },

  /**
   * Скрыть все слои (Мутация для новой версии списка слоев (#n174pm))
   * @param {*} state
   */
  hideAllLayersNew(state) {
    setVisibilityForAllLayers(state, { visibility: false })
  },

  setFieldsControlDict(state, fieldsControlDict) {
    state.fieldsControlDict = fieldsControlDict
  }
}

/**
 * Рекурсивная функция, выставляет isVisible в false. Для старой версии
 * TODO: удалить после окончательно перехода
 * @param {*} layerInfo
 */
function hideLayer(layerInfo) {
  layerInfo.isVisible = false

  if (layerInfo.children) {
    Object.values(layerInfo.children).forEach((childLayerInfo) => {
      hideLayer(childLayerInfo)
    })
  }

  if (layerInfo.objects) {
    Object.values(layerInfo.objects).forEach((objectInfo) => {
      hideLayer(objectInfo)
    })
  }
}

/**
 * Функция для установки visibility всем слоям
 * Используется чтобы скрыть все слои или выставить значение по умолчанию
 * @param {*} state
 * @param {*} param
 * @param {*} param.visibility - значение visibility, которое надо установить
 * @param {*} param.setDefault - игнорировать visibility и установить значение visibility по умолчанию
 */
function setVisibilityForAllLayers(state, { visibility = false, setDefault = false }) {
  //Изменение visibility в словаре с настройками objectLayerSettings
  let newObjectLayerSettings = {}
  Object.entries(state.objectLayerSettings).forEach(([layerSettingsKey, layerSettings]) => {
    //Получение настроек видимости по умолчанию
    let defaultSettingsVisibility = {}
    if (setDefault && layerSettings.defaultSettings) {
      defaultSettingsVisibility = {
        visibility: layerSettings.defaultSettings.visibility || false,
        zoneVisibility: layerSettings.defaultSettings.zoneVisibility || false
      }
    }

    newObjectLayerSettings[layerSettingsKey] = {
      ...layerSettings,
      //Переданное значение видимости
      visibility: visibility,
      zoneVisibility: visibility,
      //Настройки видимости по умолчанию применяются явно и имеют больший приоритет если они есть
      ...defaultSettingsVisibility
    }
  })
  state.objectLayerSettings = newObjectLayerSettings

  //Изменение visibility в словаре с объектами objectLayerItems
  let newObjectLayerItems = {}
  Object.entries(state.objectLayerItems).forEach(([objectLayerItemKey, objectLayerItem]) => {
    //Получение настроек видимости по умолчанию
    const layerSettings = state.objectLayerSettings[objectLayerItemKey]
    let defaultSettingsVisibility = {}
    if (setDefault && layerSettings && layerSettings.defaultSettings) {
      defaultSettingsVisibility = {
        visibility: layerSettings.defaultSettings.visibility || false,
        zoneVisibility: layerSettings.defaultSettings.zoneVisibility || false
      }
    }

    newObjectLayerItems[objectLayerItemKey] = {
      ...objectLayerItem
    }

    //Скрытие объектов слоя
    if (objectLayerItem.objectsInfo) {
      newObjectLayerItems[objectLayerItemKey].objectsInfo = Object.entries(objectLayerItem.objectsInfo).reduce(
        (result, [objectsInfoItemKey, objectsInfoItem]) => {
          result[objectsInfoItemKey] = {
            ...objectsInfoItem,
            //Переданное значение видимости
            visibility: visibility,
            zoneVisibility: visibility,
            //Настройки видимости по умолчанию применяются явно и имеют больший приоритет если они есть
            ...defaultSettingsVisibility
          }
          return result
        },
        {}
      )
    }

    //Скрытие дочерних слоев
    if (objectLayerItem.childrenInfo) {
      newObjectLayerItems[objectLayerItemKey].childrenInfo = Object.entries(objectLayerItem.childrenInfo).reduce(
        (result, [childrenInfoKey, childrenInfoItem]) => {
          defaultSettingsVisibility = {
            zoneVisibility: false,
            visibility: false
          }
          if (setDefault) {
            const rootParentId = childrenInfoKey.split('-')[0]
            const parentItem = objectLayerItem.childrenInfo[rootParentId]

            if (parentItem && parentItem.hasOwnProperty('default')) {
              //Если есть родитель со свойством "по умолчанию", то используем значени родетеля
              defaultSettingsVisibility.zoneVisibility = parentItem.default
              defaultSettingsVisibility.visibility = parentItem.default
            } else if (layerSettings.defaultSettings) {
              //Если есть родитель с дефолтными настройками
              defaultSettingsVisibility.zoneVisibility = layerSettings.defaultSettings.zoneVisibility || false
              defaultSettingsVisibility.visibility = layerSettings.defaultSettings.visibility || false
            } else {
              defaultSettingsVisibility.zoneVisibility = false
              defaultSettingsVisibility.visibility = false
            }
          }

          result[childrenInfoKey] = {
            ...childrenInfoItem,
            //Переданное значение видимости
            visibility: visibility,
            zoneVisibility: visibility,
            //Настройки видимости по умолчанию применяются явно и имеют больший приоритет если они есть
            ...defaultSettingsVisibility
          }
          return result
        },
        {}
      )
    }
  })
  state.objectLayerItems = newObjectLayerItems
}



// WEBPACK FOOTER //
// ./src/store/objects/mutations.js